import { InfoAlert } from '@/components/alerts';
import { CompactButton, StandardButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { CustomContentSection } from '@/components/custom-content-section';
import { useLayoutContext } from '@/contexts';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex, Title } from '@mantine/core';
import { IconRosetteDiscountCheck, IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import {
	AccordionLocation,
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const AboutSubscriptionsPage = () => {
	const navigate = useNavigate();
	const { isDesktop } = useLayoutContext();

	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={() => navigate({ to: '/home' })}>
				Close
			</CompactButton>
		),
		[navigate]
	);

	const chooseSubscriptionButton = useMemo(
		() => (
			<StandardButton onClick={() => navigate({ to: '/choose-subscription' })}>
				Continue to Subscriptions
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Subscriptions', children: closeButton }}
			footer={{ children: chooseSubscriptionButton }}
		>
			<ContentPanel>
				<InfoAlert
					classNames={{ title: styles.alertTitle }}
					icon={<IconRosetteDiscountCheck />}
					title="Thank you for creating an account!"
					w="100%"
				/>
				<CustomContentSection
					location={ContentSectionLocation.AboutSubscriptions}
					placement={ContentSectionPlacement.Top}
				/>
				<Flex direction="column" gap="lg" mb="lg" mt="lg">
					<Title order={1} className={styles.title}>
						About Curby Subscriptions.
					</Title>
				</Flex>
				<CustomContentSection
					location={ContentSectionLocation.AboutSubscriptions}
					placement={ContentSectionPlacement.Middle}
				/>
				<CurbyAccordion accordionLocation={AccordionLocation.AboutSubscriptions} />
				<CustomContentSection
					location={ContentSectionLocation.AboutSubscriptions}
					placement={ContentSectionPlacement.Bottom}
				/>
			</ContentPanel>
			{isDesktop && (
				<Flex
					direction="row"
					align="center"
					justify="center"
					pos="fixed"
					w="100%"
					bg="white"
					bottom={0}
					py="sm"
					bd="1px solid #e0e0e0"
				>
					<Flex w={400}>{chooseSubscriptionButton}</Flex>
				</Flex>
			)}
		</PrimaryLayout>
	);
};
